var _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgDownloads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2469 5104 c-61 -18 -136 -86 -165 -149 l-24 -50 0 -1392 c0 -766 -3 -1393 -8 -1393 -4 0 -156 149 -337 331 -182 182 -350 342 -374 356 -59 35 -170 44 -238 18 -57 -22 -127 -85 -156 -140 -32 -59 -31 -192 2 -255 32 -63 1198 -1229 1261 -1261 65 -34 195 -34 260 0 63 32 1229 1198 1261 1261 33 63 34 196 2 255 -29 55 -99 118 -156 140 -68 26 -179 17 -238 -18 -24 -14 -192 -174 -374 -356 -181 -182 -333 -331 -337 -331 -5 0 -8 627 -8 1393 l0 1392 -24 50 c-59 129 -208 192 -347 149z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 1701 c-96 -25 -183 -104 -209 -192 -19 -63 -22 -401 -5 -525 70 -503 470 -903 973 -973 108 -15 3044 -15 3152 0 503 70 903 470 973 973 17 124 14 462 -5 525 -19 65 -85 140 -152 172 -107 51 -243 21 -327 -73 -66 -74 -75 -114 -75 -343 0 -280 -30 -379 -153 -511 -68 -73 -132 -117 -225 -153 l-67 -26 -1515 -3 c-1483 -2 -1516 -2 -1593 18 -105 26 -177 69 -262 154 -134 135 -165 233 -165 521 0 229 -9 269 -75 343 -67 74 -185 115 -270 93z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloads);
export default __webpack_public_path__ + "static/media/downloads.f567a91eaf5987a495929f26db02343d.svg";
export { ForwardRef as ReactComponent };